
export const RCX_IFRAME_WIDTH = 300;
export const SECOND_IFRAME_WIDTH = 520;
export const IFRAME_TOGGLE_WIDTH = 16;

export enum SecondIframeState {
    Hidden = 1,
    Collapse,
    Expand,
}

export enum ScriptState {
    Pending = 'pending',
    Running = 'running',
}